import { api } from './axios';
import type {
  PaymentCreatePayload,
  PaymentCreateResponse,
  PaymentRails,
  StripeCheckoutSession,
  SupportedPaymentOptions,
} from './types';

export const getSupportedPaymentOptions = () => {
  return api.get<SupportedPaymentOptions>('payment/supported-options');
};

export const getPaymentRails = (invoiceId: string) => {
  return api.get<PaymentRails>(`payment/rails/${invoiceId}`);
};

export const createStripeCheckoutSession = (invoiceId: string) => {
  return api.post<StripeCheckoutSession>('payment/rails/stripe/session', {
    invoiceId,
  });
};

export const createPayment = (payload: PaymentCreatePayload) => {
  return api.post<PaymentCreateResponse>('payment', payload);
};
